import { useEffect, useState } from 'react';
import './App.css';
import Button from './components/Button';
import { helpRandomAuthorLink } from './helpers/helpRandomLink';

function App() {
  const [authorLink, setAuthorLink] = useState("");

  useEffect(() => {
    if (!authorLink) setAuthorLink(helpRandomAuthorLink());

    let intervalLink = setInterval(() => {
      setAuthorLink(helpRandomAuthorLink());
    }, 5000);

    return () => clearInterval(intervalLink);
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <main>
        <h1>Botones</h1>
        <Button />
        <Button variant="outline" />
        <Button variant="text" />
        <Button disableShadow />
        <div className="grid-disabled">
          <Button disabled />
          <Button variant="text" disabled />
        </div>
        <Button icon={"fa-solid fa-cart-plus"} />
        <div className="grid-sizes">
          <Button size="sm" />
          <Button size="md" />
          <Button size="lg" />
        </div>
        <div className="grid-colors">
          <Button color="default" />
          <Button color="primary" />
          <Button color="secondary" />
          <Button color="danger" />
        </div>
        <p className="icons-ref">Íconos: <a href="https://fontawesome.com/search?s=solid">https://fontawesome.com/search?s=solid</a></p>
      </main>
      <footer>
        <p className="footer-credits">creado por <a href={authorLink} target="_blank" rel="noreferrer">Javier Valeriano</a></p>
      </footer>
    </>
  );
}

export default App;
